import React from 'react';
import { clsPrefix } from '../const';
import { CnStatisticActionBaseProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticBaseAction({
  children,
  buttons = [],
  CnButton,
}: CnStatisticActionBaseProps) {
  return (
    <div className={`${clsPrefix}-action`}>
      {buttons.map((item, index) => (
        <CnButton
          key={index}
          type={item.type}
          size={item.size || 'small'}
          onClick={item.onClick}
        >
          {item.text}
        </CnButton>
      ))}
      {children}
    </div>
  );
}

export default CnStatisticBaseAction;
